import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="problem-reports--set-categories"
export default class extends Controller {
  connect() {
    this.dialog = this.element.querySelector('dialog#categories')
    this.form = this.dialog.querySelector('form')
  }

  disconnect() {
    super.disconnect()
    this.form = null
    this.dialog = null
  }

  showDialog(event) {
    event.preventDefault()
    document.querySelectorAll('dialog').forEach((dialog) => dialog.close())
    $(this.dialog.querySelector('.select2')).select2({width: '100%'})
    this.dialog.show()
  }
}
